import { render, staticRenderFns } from "./MyWithdrawAccount.vue?vue&type=template&id=71d17232&scoped=true&"
import script from "./MyWithdrawAccount.vue?vue&type=script&lang=js&"
export * from "./MyWithdrawAccount.vue?vue&type=script&lang=js&"
import style0 from "./MyWithdrawAccount.vue?vue&type=style&index=0&id=71d17232&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d17232",
  null
  
)

export default component.exports